import { selectedTransData, transModal } from "../../redux/kyc/generalSlice";
import { TransactionModal } from "../../components/TransactionModal";
import { useDispatch, useSelector } from "react-redux";
import { formatMoney } from "../../utils/FormatMoney";
import { formatDate } from "../../utils/Dateformat";
import React from "react";
import { getTransactionsState, updateSelectedTransaction } from "../../redux/transactions/getTransactionsSlice";

export const TransactionTable = ({ transactions, text }) => {
	const showModal = useSelector((state) => state.general.trans);
	const { selectedtransaction } = useSelector(getTransactionsState);

	const dispatch = useDispatch();

	const openTransModal = (data) => {
		dispatch(transModal(true));
		dispatch(selectedTransData(data));
	};


	const handleCheckboxChange = (e, reference) => {
			if (e.target.checked) {
				const updatedCheckboxes = [...selectedtransaction, reference];
				dispatch(updateSelectedTransaction(updatedCheckboxes));
			} else {
				const updatedCheckboxes = selectedtransaction.filter(
					(x) => x !== reference,
				);
				dispatch(updateSelectedTransaction(updatedCheckboxes));
			}
		};

		
	const handleCheckAllChange = (e) => {
			if (e.target.checked) {
				const updatedCheckboxes = transactions?.results
						?.filter(transaction => transaction.transaction_type === "CREDIT")
						.map(event => event.id);
				dispatch( updateSelectedTransaction(updatedCheckboxes));
			} else {
				dispatch(updateSelectedTransaction([]));
			}
		};

	return (
		<>
			{showModal && <TransactionModal />}
			<div className="transac-table">
				<table className="table">
					<thead>
						<tr>
						{/* <th>
								{" "}
								<input
									type="checkbox"
									// checked={isCheckedAll}
									onChange={handleCheckAllChange}
								></input>
							</th> */}
							<th>AMOUNT</th>
							<th>MEMO</th>
							<th>REF</th>
							<th>SESSION ID</th>
							<th>STATUS</th>
							<th>DATE &amp; TIME</th>
							<th>TYPE</th>
						</tr>
					</thead>
					<tbody>
						{transactions?.results?.length > 0 ? (
							transactions?.results?.map((transaction) => (
								<tr
									key={transaction.transaction_ref}
									
									className="trans"
								>
									{/* <td>
									{" "}

									{transaction.transaction_type === "CREDIT" && <input
										type="checkbox"
										checked={
											selectedtransaction.find(
												(checkbox) =>
													checkbox ===
												transaction.id,
											) != null
												? true
												: false
										}
										onChange={(e) => handleCheckboxChange(
												e,
												transaction.id,
											)}
									></input> }
									
								</td> */}
									<td onClick={() => openTransModal(transaction)}> ₦{formatMoney(transaction?.amount)}</td>
									<td onClick={() => openTransModal(transaction)}>{transaction.description}</td>
									<td>{transaction.transaction_ref}</td>
									<td>{transaction.session_id}</td>
									<td>
										{" "}
										<span
											className={
												transaction.status ===
												"SUCCESSFUL"
													? "btn-success "
													: transaction.status ===
													  "FAILED"
													? "btn-danger"
													: "btn-warn"
											}
										>
											{transaction.status}
										</span>
									</td>
									<td>
										{formatDate(
											transaction.created_datetime,
										)}
									</td>
									<td>
										{" "}
										<span
											className={
												transaction.transaction_type ===
												"DEBIT"
													? "transaction_type trans-debit"
													: "transaction_type trans-credit"
											}
										>
											{" "}
											{transaction.transaction_type}{" "}
										</span>
									</td>
								</tr>
							))
						) : (
							<>
								<tr>
									<td colSpan="6">
										<div className="emtyTransactions">
											<img
												src={`../images/empty.png`}
												className="empty"
												alt="empty "
											/>
											<p>{text}</p>
										</div>
									</td>
								</tr>
							</>
						)}
					</tbody>
				</table>
			</div>
		</>
	);
};
